import PropTypes from "prop-types";

export default {
	warning: PropTypes.bool,
	error: PropTypes.bool,
	small: PropTypes.bool,
	label: PropTypes.string,
};
